import React from 'react';
import FileUploadMetadata from 'components/pure/call-card/FileUploadMetadata';
import './AddToReview.styl';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import {List} from 'immutable';
import CoachingReviewFileUpload from 'records/CoachingReviewFileUpload';
import AuthStore from 'stores/AuthStore';
import ToastStore from '@store/toast/ToastStore';
import ContentDetailSelector from 'components/coaching/ContentDetailSelector';
import RadioField from 'components/pure/utils/form/RadioField';
import classNames from 'classnames';
import CoachingContentDetailScore from 'records/CoachingContentDetailScore';
import {browserHistory} from 'react-router';
import urlParams from 'utils/urlParams';
import SharingActions from 'actions/sharing/SharingActions';
import SharingFormActions from 'actions/sharing/SharingFormActions';

export default class AddToReview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlan: undefined,
      selectedReview: undefined,
      selectedReviewFileUpload: undefined,
    };
  }

  componentDidMount() {
    if (this.props.standalone) {
      this.props.onLoad(this.addCallToReview, this.isDisabled);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      // if we're visible, set up our submit/disabled logic.
      this.props.onLoad(this.addCallToReview, this.isDisabled);
    }
  }

  onSelect(s, fileUpload) {
    const [review, reviewFileUpload] = this.getFor(s, fileUpload.id);
    this.setState({
      selectedPlan: s,
      selectedReview: review,
      selectedReviewFileUpload: reviewFileUpload,
    });
  }

  addCallToReview = async () => {
    const {selectedPlan: planFromState} = this.state;
    const {fileUpload, applicableCoachingPlans, reviewRedirect} = this.props;

    const selectedPlan = planFromState ? planFromState : applicableCoachingPlans.get(0);

    const [selectedReview, selectedReviewFileUpload] = this.getFor(selectedPlan, fileUpload.id);

    await CoachingReviewActions.updateReviewFileUploads(
      selectedReview.id,
      List([selectedReviewFileUpload])
    ).then(() => {
      ToastStore.addToast({
        message: 'Added call to review!',
        type: 'success',
      });
      this.setState({
        selectedPlan: undefined,
        selectedReview: undefined,
        selectedReviewFileUpload: undefined,
      });
      SharingActions.closeSharingDialog();
      SharingFormActions.reset();
    });

    if (reviewRedirect) {
      const query = urlParams({
        planId: selectedPlan.id,
        reviewId: selectedReview.id,
      });
      browserHistory.push(`/coaching/rep/${selectedPlan.recipient.id}${query}`);
    }
  };

  isDisabled = () => {
    const {selectedPlan: planFromState} = this.state;
    const {fileUpload, applicableCoachingPlans} = this.props;

    const selectedPlan = planFromState ? planFromState : applicableCoachingPlans.get(0);

    const [, selectedReviewFileUpload] = this.getFor(selectedPlan, fileUpload.id);

    return selectedReviewFileUpload.reviewFeedbackList.size === 0;
  };

  /**
   * Get the review and review fileupload x content detail info based on which
   * plan was chosen.  Coalesce to sane defaults (all content details chosen)
   * upon choosing a plan.
   *
   * @param selectedPlan - selected plan
   * @param fid - fileupload id
   * @return [review, reviewFileupload]
   */
  getFor(selectedPlan, fid) {
    const {selectedReview: fromStateReview, selectedReviewFileUpload: fromStateReviewFileupload} =
      this.state;

    return [
      fromStateReview || selectedPlan.reviews.find(r => r.status === 'SCHEDULED'),
      fromStateReviewFileupload ||
        new CoachingReviewFileUpload({
          id: null,
          addedByUserId: List([AuthStore.getState().user.id]),
          fileuploadId: fid,
          reviewFeedbackList: selectedPlan.contentDetails.map(
            contentDetail => new CoachingContentDetailScore({contentDetail})
          ),
        }),
    ];
  }

  render() {
    const {selectedPlan: planFromState} = this.state;
    const {applicableCoachingPlans, skills, fileUpload} = this.props;

    if (!applicableCoachingPlans) {
      return null;
    }

    const selectedPlan = planFromState ? planFromState : applicableCoachingPlans.get(0);
    const [selectedReview, selectedReviewFileUpload] = this.getFor(selectedPlan, fileUpload.id);

    return (
      <div className="add-call-to-review-dialog">
        <FileUploadMetadata fileUpload={fileUpload} duration={fileUpload.fields.Duration} />

        <div className="inner-wrapper">
          <p className="instructions">
            Share this call to the next coaching session. This will automatically add the call to
            the review meeting page, so that you can listen to it in the coaching session.
          </p>

          <div className="form-items">
            <div className="form-item">
              <label className="field-label">Coaching Plan</label>
              <div className="choose-plan">
                {applicableCoachingPlans.map((s, i) => (
                  <div
                    key={i}
                    className={classNames(['plan-select', selectedPlan === s && 'active'])}>
                    <RadioField
                      label={
                        <div>
                          <div className="coaching-plan-name">{s.name}</div>
                          <div>
                            {s.coach.info.getFullName() + ' and ' + s.recipient.info.getFullName()}
                          </div>
                        </div>
                      }
                      checked={selectedPlan === s}
                      value={s}
                      onClick={() => this.onSelect(s, fileUpload)}
                    />
                    {selectedPlan &&
                      selectedReview &&
                      selectedPlan.contentDetails.size > 0 &&
                      selectedPlan === s && (
                        <div className="form-item">
                          <ContentDetailSelector
                            skills={skills}
                            coachingPlan={selectedPlan}
                            reviewFileUpload={selectedReviewFileUpload}
                            onChange={v => {
                              this.setState({
                                selectedReviewFileUpload: v,
                              });
                            }}
                            immutable={false}
                          />
                        </div>
                      )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
